import IconImage from "../../../public/images/image.svg";
import EditorPanelButton from "../buttons/EditorPanelButton";
import {useTranslation} from "next-i18next";
import Select from "./Select";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import {useCallback} from "react";
import PropTypes from "prop-types";

const ImageSelect = ({images}) => {
  const store = useEditorPanelButtonStore();
  const {t} = useTranslation();

  const handleAddImageClick = useCallback(() => {
    store.setIsImageModalOpen(true);
  }, [store.setIsImageModalOpen]);

  const buttonContent = <div className="select__button-text">
    <IconImage className="select__icon"/>
    <span>{t(`convert-and-edit:editor.image`)}</span>
  </div>

  return (
    <Select tab='image' buttonContent={buttonContent}>
      <div className={`sign-select__block ${store.isOpenModal !== 'image' ? "select__list-hide" : ""}`}>
        <ul className="sign-select__list">
          {images}
        </ul>
        <EditorPanelButton text="new-image" onClick={handleAddImageClick}/>
      </div>
    </Select>
  );
};

ImageSelect.propTypes = {
  images: PropTypes.array,
};

export default ImageSelect;
